import { CatalogLostStrandTypesPage } from "./CatalogLostStrandTypes";
import { CatalogLostStrandTypesProvider } from "./CatalogLostStrandTypesContext";

const CatalogLostStrandTypes = () => {
	return (
		<CatalogLostStrandTypesProvider>
			<CatalogLostStrandTypesPage />
		</CatalogLostStrandTypesProvider>
	);
};

export default CatalogLostStrandTypes;
